/**
 * conferenceManagerRef: ConferenceManager 전역 참조.
 *
 * VideoRenewalPage / VideoPage 에서 setConferenceManager()로 등록하고,
 * ContextMenu 등 하위 컴포넌트에서 getConferenceManager()로 직접 접근한다.
 *
 * prop-drilling 없이 kick / mute 등의 회의 제어 메서드를 호출하기 위한 최소 전역 참조.
 */
import type ConferenceManager from './ConferenceManager';

let _instance: ConferenceManager | null = null;

export function setConferenceManager(m: ConferenceManager | null): void {
  _instance = m;
}

export function getConferenceManager(): ConferenceManager | null {
  return _instance;
}
